module.exports = __webpack_public_path__ + "media/images/2-e70f930e1b9664328b6f4403ceae31d4.png";